import { useSearchParams } from "react-router-dom";

import useBillingContext from "@app/analytics/hooks/billing/useBillingContext";
import { pluralize } from "@app/common/utils";

import Alert from "@rui/Alert";

const SubscriptionPurchaseBanner = () => {
  const { licenses } = useBillingContext();
  const [queryParams] = useSearchParams();

  const fromParam = queryParams.get("from");

  if (fromParam !== "subscription_purchase") return null;

  return (
    <Alert sx={{ borderRadius: 0 }}>
      Your Read plan has been successfully updated. Create a Workspace and
      invite people to use your{" "}
      {pluralize(
        "additional license",
        `${licenses.numUnclaimed} additional licenses`,
        licenses.numUnclaimed
      )}
      .
    </Alert>
  );
};

export default SubscriptionPurchaseBanner;
